<template>
  <div class="containerfluid">
    <div class="row">
      <div class="mb-3">
        <a
          v-if="!AddMode"
          class="d-inline float-right mx-2 mt-1"
          href="javascript:;"
          @click="
            AddMode = !AddMode
            addnew()
          "
          title="افزودن روش دسترسی جدید"
        >
          <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
        </a>
        <a v-if="AddMode" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = !AddMode" title="لغو افزودن">
          <h4><i class="fas fa-times text-danger"></i></h4>
        </a>
      </div>
      <div v-if="AddMode" class="col-12 p-4">
        <div class="row" id="RemoteAccess">
          <div class="col-lg-4 col-12">
            <small :id="'Lbl' + 'tblCombogrp44IdAccessType'"> نوع ارتباط </small>
            <SearchableCombo
              :edit="false"
              :grp="44"
              :code="null"
              @ResultCombo="GetResulttblCombogrp44IdAccessType"
              :rownumintable="3"
              :defaultvalue="this.DataAxios.ArryfildValue.tblCustomerRemoteAccess.tblCombogrp44IdAccessType"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'tblCombogrp44IdAccessType'"
              :keyItem="'State'"
              :ClassProps="'required'"
              :disabled="false"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblAddress">Address</small>
            <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.tblCustomerRemoteAccess.Address" />
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblUsername">Username</small>
            <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.tblCustomerRemoteAccess.Username" />
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblPassword">Password</small>
            <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.tblCustomerRemoteAccess.Password" />
          </div>
          <div class="col-lg-4 col-12">
            <small id="LblInfoDes">توضیحات</small>
            <textarea class="form-control" v-model="DataAxios.ArryfildValue.tblCustomerRemoteAccess.InfoDes"></textarea>
          </div>
          <div class="col-lg-4 col-12">
            <small>دادن دسترسی به کاربر</small>
            <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'" :disabled="false"> </SearchableCombo>
          </div>
        </div>
        <div class="col-lg-8 col-12"></div>
        <div class="col-12">
          <div class="row borde p-4 Rounded">
            <div class="col-12 p-2"><h6>کاربران دارای دسترسی:</h6></div>
            <div class="col-12">
              <span class="badge border m-1 p-2" v-for="(ra, index) in DataAxios.ArryfildValue.tblCustomerRemoteAccessUsers" :key="index">
                {{ ra.Name }} &nbsp;&nbsp;
                <i @click="RemoveUser(ra)" class="fas fa-times hover-danger"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12">
          <button v-if="status == 'add'" @click="addAccess" class="btn btn-success mt-4 w-100">ثبت دسترسی راه دور</button>
          <button v-if="status == 'edit'" @click="EditAccess" class="btn btn-warning mt-4 w-100">ثبت تغییرات</button>
        </div>
      </div>
      <div v-if="AccessList.length < 1 && !AddMode" class="col-12 p-4 border Rounded">
        <h4>روش ارتباطی ثبت نشده است.</h4>
      </div>
      <div v-if="AccessList.length > 0 && !AddMode" class="col-12 p-4">
        <div class="row">
          <div v-for="(item, index) in AccessList" :key="index" class="col-lg-4 col-6 mt-2">
            <CardBox>
              <template v-slot:cardbox-icon1><i class="fad fa-laptop-house"></i></template>
              <template v-if="item.tblCustomerRemoteAccess.Password !== '***'" v-slot:b-dropdown-item>
                <b-dropdown-item @click="Edit(item.tblCustomerRemoteAccess)" href="#" class="text-center">ویرایش </b-dropdown-item>
                <b-dropdown-item @click="DeleteQuestion(item.tblCustomerRemoteAccess)" href="#" class="text-center">حذف</b-dropdown-item>
              </template>
              <template v-slot:cardbox-body>
                <h5>{{ item.tblCustomerRemoteAccess.Name }}</h5>
                <div class="row mt-4 text-left" >
                  <!-- <div class="col-1"></div> -->
                  <div class="col-12 t">
                    <p class="card-text detail">
                      <span style="font-size: small" class="text-info">Address:</span>
                      <span v-if="item.tblCombogrp44IdAccessType != 1808"> {{ item.tblCustomerRemoteAccess.Address }} </span>
                      <span v-else>
                        <a class="text-warning" :href="'anydesk:' + item.Address"> {{ item.tblCustomerRemoteAccess.Address }} </a>
                      </span>
                      <i class="fad fa-at text-info"></i>
                    </p>
                    <p class="card-text detail">
                       <span class="text-info"> Username:</span> {{ item.tblCustomerRemoteAccess.Username }}  <i class="fas fa-user text-info"></i>
                    </p>
                    <p class="card-text detail">
                      <span class="text-info">Password:</span> {{ item.tblCustomerRemoteAccess.Password }} <i class="fas fa-key text-info"></i>
                    </p>
                    <p class="card-text detail">
                      {{ item.tblCustomerRemoteAccess.InfoDes }} <span class="text-info"> :توضیحات &nbsp;<i class="fas fa-dots text-info"></i></span>
                    </p>
                  </div>
                  <!-- <div class="col-1"></div> -->
                </div>
              </template>
            </CardBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardBox from '@/components/CardBox/CardBox.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  data() {
    return {
      status: 'add',
      AddMode: false,
      Address: [],
      NewAccess: {
        tblCustomerRemoteAccess: {
          Id: 77,
          InfoDes: null,
          Password: null,
          tblCustomerId: this.CustomerId,
          Username: null,
          Address: null,
          tblCombogrp44IdAccessType: '',
          TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
        },
        tblCustomerRemoteAccessUsers: [{ Id: 10, tblRemoteAccessId: 55, tbluserId: this.$session.get('UserInfo').tblUserId, tblusergrpIdInsert: this.$session.get('UserInfo').tblUserGrpId, datetimeInsert: '', Name: this.$session.get('UserInfo').namFam }],
      },
      DataAxios: {
        Action: 'TblCustomerRemoteAccess/Add',
        Method: 'Post',
        ArryfildValue: {},
      },
      rendergrid: true,
    }
  },
  props: ['CustomerId', 'AccessList'],
  components: { CardBox, SearchableCombo },
  methods: {
    GetResulUserId(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblCustomerRemoteAccessUsers.push({ Id: 10, tblRemoteAccessId: 55, tbluserId: data.id, tblusergrpIdInsert: this.$session.get('UserInfo').tblUserGrpId, datetimeInsert: '', Name: data.name })
      }
    },
    RemoveUser(data) {
      this.DataAxios.ArryfildValue.tblCustomerRemoteAccessUsers.splice(this.DataAxios.ArryfildValue.tblCustomerRemoteAccessUsers.indexOf(this.DataAxios.ArryfildValue.tblCustomerRemoteAccessUsers.find((x) => x.tbluserId == data.tbluserId)), 1)
    },
    addnew() {
      this.DataAxios.ArryfildValue = this.NewAccess
      this.status = 'add'
    },
    GetResulttblCombogrp44IdAccessType(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblCustomerRemoteAccess.tblCombogrp44IdAccessType = data.id
      }
    },
    addAccess() {
      if (this.$ValidForm('RemoteAccess')) {
        this.$PostData(this.DataAxios).then((result) => {
          if (result.status == 'success') {
            this.$mySweetDefaultTost('عملیات موفق', 'روش دسترسی جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 5,
            })
            this.AddMode = false
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت اطلاعات بوجود آمده است', 'warning', 2000)
          }
        })
      }
    },
    Edit(data) {
      this.status = 'edit'
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.AccessList.find((x) => x.tblCustomerRemoteAccess.Id == data.Id)))
      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios.ArryfildValue)
      this.AddMode = true
    },
    EditAccess() {
      var DataAxiosEdit = JSON.parse(JSON.stringify(this.DataAxios))
      DataAxiosEdit.Method = 'PUT'
      DataAxiosEdit.Action = 'TblCustomerRemoteAccess/Edit'
      DataAxiosEdit.ArryfildValue.tblCustomerRemoteAccess.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      if (this.$ValidForm('RemoteAccess')) {
        this.$PostData(DataAxiosEdit).then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'دسترسی  با موفقیت اصلاح شد', 'success', 2000)
            this.$SetLog(DataAxiosEdit.ArryfildValue, 0, 0, 'RemoteAccess', 'دسترسی راه دور')
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 5,
            })
          }
        })
      }
    },
    DeleteAcces(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      var DataAxiosEdit = {
        Action: 'TblCustomerRemoteAccess/Delete',
        Method: 'Delete',
        ArryfildValue: {
          id: JSON.parse(JSON.stringify(data.Id)),
        },
      }

      this.$PostData(DataAxiosEdit).then((result) => {
        if (result.status == 'success') {
          this.AddMode = false
          this.$mySweetDefaultTost('عملیات موفق', 'دسترسی راه دور  با موفقیت حذف شد', 'success', 2000)
          this.$SetLog(DataAxiosEdit.ArryfildValue, 1, 0, 'RemoteAcess', 'دسترسی راه دور')

          this.$emit('Inserted', {
            done: 'OK',
            activeTab: 5,
          })
        }
      })
    },
    DeleteQuestion(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف ادرس اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.DeleteAcces, this.cancel)
    },
  },
}
</script>
<style scoped></style>
